import { render, staticRenderFns } from "./ViewWallet.vue?vue&type=template&id=c6faacb2&"
import script from "./ViewWallet.vue?vue&type=script&lang=js&"
export * from "./ViewWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports